module.exports = __webpack_public_path__ + "static/media/peso-cycle.c5149055.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peso-cycle.svg
// module id = 1065
// module chunks = 2